<template>
  <b-modal
    modal-class="component-modal-product"
    id="categoryItemModal"
    ref="categoryItemModal"
    size="lg"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
  >
    <b-form id="categoryTable" @submit.prevent="saveCategory">
      <b-form-group label-cols="3" label="รหัสหมวดหมู่:" label-align="right">
        <b-form-input
          class="required"
          id="categoryCode"
          v-model="categoryItem.categoryCode"
          :class="{ 'is-invalid': $v.categoryItem.categoryCode.$error }"
          maxlength="20"
          placeholder="กรอกรหัสของหมวดหมู่สินค้า"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group label-cols="3" label="ชื่อหมวดหมู่:" label-align="right">
        <b-form-input
          class="required"
          id="categoryNameTh"
          v-model="categoryItem.categoryNameTh"
          :class="{ 'is-invalid': $v.categoryItem.categoryNameTh.$error }"
          maxlength="100"
          placeholder="กรอกชื่อหมวดหมู่ภาษาไทย"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group
        label-cols="3"
        label="ชื่อหมวดหมู่ (Eng):"
        label-align="right"
      >
        <b-form-input
          id="categoryNameEn"
          maxlength="100"
          v-model="categoryItem.categoryNameEn"
          placeholder="กรอกชื่อหมวดหมู่ภาษาอังกฤษ"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer>
      <b-button
        v-if="!isNewCategory"
        variant="danger"
        @click="deleteCategory(categoryItem)"
        >ลบรายการ</b-button
      >
      <b-button type="submit" form="categoryTable" variant="primary">
        {{ isNewCategory ? "สร้างรายการ" : "แก้ไขรายการ" }}
      </b-button>
    </template>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import { maxLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import "@/theme/modal/Package.scss";

export default {
  name: "CategoryCreateModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "รายการหมวดหมู่สินค้า",
      isNewCategory: true,
      categoryItem: {
        categoryId: "",
        categoryCode: "",
        categoryNameTh: "",
        categoryNameEn: "",
      },
    };
  },
  validations: {
    categoryItem: {
      categoryCode: {
        required,
        maxLength: maxLength(20),
      },
      categoryNameTh: {
        required,
        maxLength: maxLength(100),
      },
      categoryNameEn: {
        maxLength: maxLength(100),
      },
    },
  },
  computed: {
    ...mapGetters({
      getCategoryList: "moduleCategoryMaster/getCategoryList",
    }),
  },
  methods: {
    ...mapActions({
      fetchCategoryList: "moduleCategoryMaster/fetchCategoryList",
    }),
    show(data) {
      if (data) {
        this.isNewCategory = false;
        this.categoryItem = Object.assign({}, data);
      } else {
        this.isNewCategory = true;
        this.setDefaultValue();
      }
      this.$bvModal.show("categoryItemModal");
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
      this.isNewCategory = true;
      this.$bvModal.hide("categoryItemModal");
    },
    reloadCategoryList() {
      this.fetchCategoryList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
    setDefaultValue() {
      this.categoryItem = Object.assign(
        {},
        {
          categoryCode: "",
          categoryNameTh: "",
          categoryNameEn: "",
        }
      );
    },
    saveCategory() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;

      const adjustCategoryItem = {
        code: this.categoryItem.categoryCode,
        description: this.categoryItem.categoryNameTh,
        description2: this.categoryItem.categoryNameEn,
      };

      if (this.isNewCategory) {
        this.$store
          .dispatch("moduleCategoryMaster/createCategoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustCategoryItem: adjustCategoryItem,
          })
          .then(res => {
            if (res.status == 201) {
              this.reloadCategoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "เพิ่มรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "เพิ่มรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("moduleCategoryMaster/updateCategoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustCategoryItem: adjustCategoryItem,
            id: this.categoryItem.categoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadCategoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "แก้ไขรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "แก้ไขรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteCategory(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหมวดหมู่สินค้านี้ ?",
        "คุณต้องการลบหมวดหมู่สินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;
        this.$store
          .dispatch("moduleCategoryMaster/deleteCategoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: this.categoryItem.categoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadCategoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "ลบรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
